import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-freewill-pay',
  templateUrl: './review-freewill-pay.component.html',
  styleUrls: ['./review-freewill-pay.component.scss']
})
export class ReviewFreewillPayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
